export class DployContextStore {
	declare static context: Record<string, string>;
}
